import { nameof } from "bindable-data";
import { HBox } from "../../../../common/components/HBox";
import { PlayerModel } from "../../../../common/models/PlayerModel";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { VictoryPopupController } from "../controllers/VictoryPopupController";
import { VictoryResourcesPackage } from "../resources/VictoryResourcesPackage";
import { BoosterPurchaseComponent } from "./BoosterPurchaseView";
import { IDestroyOptions } from "pixi.js";
import { BoosterType } from "../../../../common/models/data/BoosterType";
import { AudioController, Sfx } from "../../../game/components/AudioController";
import { BoostersConfiguration } from "../../../../common/models/BoostersConfiguration";

export class BoostersPurchasePanel extends HBox {
    public get width(): number {
        return 620;
    }
    private readonly boosters: Map<BoosterType, BoosterPurchaseComponent>;

    public constructor(
        private readonly commonResources: CommonResourcesPackage,
        private readonly victoryResources: VictoryResourcesPackage,
        private readonly playerModel: PlayerModel,
        private readonly boostersConfiguration: BoostersConfiguration,
        private readonly victoryController: VictoryPopupController,
        private readonly audioController: AudioController
    ) {
        super(15);
        this.boosters = new Map();

        for (const [booster, info] of playerModel.boosters) {
            const [count, _usageCount, level] = info;
            const boosterButton = new BoosterPurchaseComponent(this.commonResources, this.victoryResources, booster, count, level, boostersConfiguration.getConfiguration(booster, level).price);
            boosterButton.onPurchaseClick.add(() => this.onBoosterPurchaseClick(booster));
            this.addChild(boosterButton);
            this.boosters.set(booster, boosterButton);
        }
        this.playerModel.propertyChanged.add(this.onPlayerModelPropertyChange, this);
    }

    public lockButtons(): void {
        for (const [booster, _] of this.playerModel.boosters) {
            const button = this.boosters.get(booster);
            button.lockButton();
        }
    }

    public unlockButtons(): void {
        for (const [booster, _] of this.playerModel.boosters) {
            const button = this.boosters.get(booster);
            button.unlockButton();
        }
    }

    private onBoosterPurchaseClick(type: BoosterType): void {
        if(this.victoryController.purchaseBooster(type)) {
            this.audioController.playSfx(Sfx.PurchaseItem);
        }
    }

    private onPlayerModelPropertyChange(model: PlayerModel, key: string): void {
        if (key != nameof(model, "boosters")) {
            return;
        }
        for (const [booster, info] of model.boosters) {
            const [count, _usageCount, level] = info;
            const button = this.boosters.get(booster);
            if (button.count == count) {
                continue;
            }
            button.count = count;
        }
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        for (const [_booster, boosterButton] of this.boosters) {
            boosterButton.onPurchaseClick.removeAll();
        }
        this.playerModel.propertyChanged.remove(this.onPlayerModelPropertyChange, this);
        super.destroy(options);
    }
}